import { useState, useCallback } from 'react'

/**
 * Hook for managing message expansion state
 * Handles expanded accordions for API messages and submitted forms
 */
export function useMessageExpansion() {
  const [expandedMessages, setExpandedMessages] = useState(new Set())
  const [expandedForms, setExpandedForms] = useState(new Set())

  const toggleMessageExpansion = useCallback((messageIndex) => {
    setExpandedMessages(prev => {
      const newExpanded = new Set(prev)
      if (newExpanded.has(messageIndex)) {
        newExpanded.delete(messageIndex)
      } else {
        newExpanded.add(messageIndex)
      }
      return newExpanded
    })
  }, [])

  const toggleFormExpansion = useCallback((formKey) => {
    setExpandedForms(prev => {
      const newExpanded = new Set(prev)
      if (newExpanded.has(formKey)) {
        newExpanded.delete(formKey)
      } else {
        newExpanded.add(formKey)
      }
      return newExpanded
    })
  }, [])

  const isMessageExpanded = useCallback((messageIndex) => {
    return expandedMessages.has(messageIndex)
  }, [expandedMessages])

  const isFormExpanded = useCallback((formKey) => {
    return expandedForms.has(formKey)
  }, [expandedForms])

  return {
    expandedMessages,
    expandedForms,
    setExpandedForms,
    toggleMessageExpansion,
    toggleFormExpansion,
    isMessageExpanded,
    isFormExpanded
  }
}

export default useMessageExpansion
